export const SHOW_LOADING = '[ui] show loading';
export const HIDE_LOADING = '[ui] hide loading';
export const UPDATE_API_SPINNER = '[ui] update api spinner';
export const CLEAR_UI_MSG = '[ui] ui message cleared';
export const ADD_UI_MSG = '[ui] ui message added';

export const showLoading = () => ({
  type: SHOW_LOADING,
});

export const hideLoading = () => ({
  type: HIDE_LOADING,
});

export const updateApiSpinner = (payload) => ({
  type: UPDATE_API_SPINNER,
  payload,
});

export const clearUiMsg = (messageId) => ({
  type: CLEAR_UI_MSG,
  payload: messageId,
});

export const addUiMsg = (message) => ({
  type: ADD_UI_MSG,
  payload: message,
});
